define(["dojo/_base/declare",
	"dojo/_base/lang",
	"csi",
	"csi/def",
	"csi/def/Field",
	"csi/def/Relationship",
	"csi/form/Widget",
	"csi/xml",
	"csi/xml/Query"
], function(declare, lang, csi, def, Field, Relationship, FormWidget, xml, Query) {

	return declare(FormWidget, {

		_resolveView: function() {
			//var parentView_id = this.viewParent ? this.viewParent.defView.m_id : null;
			var viewNode = this.getViewNode();

			this.defView.addField(lang.mixin(new Field(), {
				m_id: "SupplierItem",
				idParameter: "SupplierItem",
				m_bRequired: true,
				m_typeControl: def.FIELD_FILTERING_SELECT,
				m_relationship: lang.mixin(new Relationship(), {
					m_typeNode: "SupplierItem",
					m_query: new Query()
						.RefAttr("QuoteCostScenario", xml.OP_NOT_EQUALS, csi.EMPTY_URL, "Child:LatestRevision")
						.RefAttr("QuoteBOM", xml.OP_EQUALS, viewNode.__Parent__, "Child:LatestRevision")
						.Attr("State", xml.OP_NOT_EQUALS, "Revision.State:ABANDONED", "Child:LatestRevision")
				})
			}));

			this.inherited(arguments);
		}
	});
});